import React from 'react'
import { useSelector } from 'react-redux'

const withApiData = Child => {
  return props => {
    const apiData = useSelector(state => ({
      token: state.auth.token,
      orgId: state.organization.orgId,
      isMentor: state.auth.isMentor
    }))
    return <Child {...props} apiData={apiData} />
  }
}

export default withApiData
